export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;

  function modifyTitle(data) {
    const text = data.items[0].Title;
    const subTitle = text.split('-')[0];
    const title = text.split('-')[1];
    const fullTitle = `<span class="blue-text">${subTitle}</span><span class="red-text">${title}</span>`;

    $(`#${widgetName} .card-widget-title`).html(fullTitle);
    // change .card-widget-title to a h1 tag
    $(`#${widgetName} .card-widget-title`).replaceWith(function () {
      return $('<h1>', {
        html: $(this).html(),
        class: $(this).attr('class'),
        // add aria label
        'aria-label': $(this).text(),
      });
    });
  }

  function modifyParagraph(data) {
    const text = data.items[0].Description;
    const paragraphs = text.split('\n');
    let paragraph = '';
    paragraphs.forEach((p) => {
      paragraph += `<p>${p}</p>`;
    });

    $(`#${widgetName} .card-widget-description`).html(paragraph);
  }

  function modifyButton(data) {
    const buttonTitle = data.items[0].DetailLinkText;
    $(`#${widgetName} .moreButton`)
      .text(buttonTitle)
      .removeClass('moreButton')
      .addClass('button');
    $('#seoWidget .buttonwrap').appendTo('#seoWidget .card-widget-description');
    if (buttonTitle.length > 18) {
      $(`#${widgetName} .button`).text(`${buttonTitle.slice(0, 18)}...`);
    }
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (data) {
      console.log(data)
      modifyTitle(data);
      modifyParagraph(data);
      modifyButton(data);
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}
